/**
 * Event contains ULM URL appended with login parameters.
 *
 */
export var LOGIN_URL_EVENT = "login_url";
/**
 * Event contains profile information returned from ULM
 */
export var ULM_PROFILE_EVENT = "ulm_profile";
